import React, {Component} from 'react';
import {connect} from 'react-redux'
import StockTyreSearchPage from 'view/tyre/stock/StockTyreSearchPage';
import StockTransactionReport from 'view/stock/StockTransactionReport';
// import StockOutOfStockReport from 'view/stock/StockOutOfStockReport';
// import StockCheckReport from 'view/stock/StockCheckReport'
//import StockWarehouseManagementModal from 'view/stock/StockWarehouseManagementModal'
// import ReportStoreOutPage from 'view/report/ReportStoreOutPage'
// import StockAnyExportReport from 'view/stock//StockAnyExportReport'
import { Tabs, Tab, Row, Col } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import StockStore from 'stores/StockStore';
// import ReportStore from 'stores/ReportStore';
import {compose} from 'redux'
import withSizes from 'react-sizes'

class StockTyreManagementPage extends Component {

  constructor(props) {
    super(props)
    this.state = { 
      
      length: 10,

      totalPage: 0,
      data: [],
      loading: false,
      warehouse:[],

      // totalPageOutOfStock: 0,
      // dataOutOfStock: [],
      // loadingOutOfStock: false,
      tabSelect:'activetyre',
      subTabSelect:'search',
      showAdd:false
    }
    
  }

  componentDidMount(){
    
    this.refs['activetyre-search'].getWrappedInstance().loadData()
    this.loadWarehouse()
  }

  componentWillMount(){
    if(this.props.onRef!==undefined){
      this.props.onRef(this)
    }
  }
  
  loadWarehouse() {
    StockStore.loadWarehouse((result)=>{
      this.setState({warehouse:result.data})
    })
  }

  handleSelect(type) {   
    let {subTabSelect} = this.state
    // if (type=='setting') {
    //   this.setState({showAdd:true})
    // } else {
    //   this.setState({tabSelect:type})
    //   if (type!='pickup'&&type!='report-store-out') {
    //     if(subTabSelect==='search'){
    //       this.refs[type+'-search'].getWrappedInstance().loadData()
    //     }else if(subTabSelect==='inout'){
    //       this.loadStockTransaction(type, '', '', '', '', '')
    //     }else if(subTabSelect===3){
    //       this.loadOutOfStockReport(type, '')
    //     }
    //   } else if (type=='report-store-out') {
    //     this.refs['genpart-report-store-out'].getWrappedInstance().loadData()
    //   } 
    // }

    if (type==='setting') {
      this.setState({showAdd:true})
    } else {
      if(subTabSelect==='search'){
        this.refs[type+'-search'].getWrappedInstance().loadData()
      }else if(subTabSelect==='inout'){
        this.loadStockTransaction(type, '', '', '', '', '')
      } 
      this.setState({tabSelect:type})
    }   
  }

  subHandleSelect(type, key) {
    // if( key==='search'){
    //   this.refs[type+'-search'].getWrappedInstance().loadData()
    // }
    // else if (key === "inout") {
    //   this.loadStockTransaction(type, '', '', '', '', '')
    // } else if (key === 3) {
    //   this.loadOutOfStockReport(type, '')
    //   this.refs[type+'-outofstock'].getWrappedInstance().loadCategory()
    // }else if (key === "check") {
    //   this.refs[type+'-check'].getWrappedInstance().loadData()
    // }
    if( key==='search'){
      this.refs[type+'-search'].getWrappedInstance().loadData()
    }
    else if (key === "inout") {
      this.loadStockTransaction(type, '', '', '', '', '')
    }
    this.setState({subTabSelect:key})
  }

  // loadOutOfStockReport(type, start = 0) {
  //   let that = this
  //   this.setState({loadingOutOfStock: true})

  //   ReportStore.loadOutOfStockList(type, start, this.state.length, function(result) {
      
  //     const totalPage = result.total_count / 10
  //     that.setState({loadingOutOfStock: false, dataOutOfStock: result.data, totalPageOutOfStock: Math.ceil(totalPage)})
  //   })
  // }

  onReloadWarehouse(items) {
    this.setState({warehouse:items})
  }

  onReloadStockList() {
    let {tabSelect} = this.state
    if (this.refs[tabSelect+'-search']!==undefined)
      this.refs[tabSelect+'-search'].getWrappedInstance().loadData()
    else {
      this.setState({tabSelect:'genpart'})
      this.refs['genpart-search'].getWrappedInstance().loadData()
    }  
  }

  onShowAddHide() {
    this.setState({showAdd:false})
  }

  // onOutOfStockReportLoad(e) {
  //   this.loadOutOfStockReport(e.type, e.start)
  // }

  loadStockTransaction(type, year = '', month = 0, record_type = '', start = 0, length = 10) {
    let that = this
    this.setState({loading: true})

    StockStore.loadStockTransaction(type, year, month, record_type, start, this.state.length,'','',function(result) {

      const totalPage = result.total_count / 10
      that.setState({loading: false, data: result.data, totalPage: Math.ceil(totalPage)})
    })
  }

  onStockTransactionLoad(e) {
    this.loadStockTransaction(e.type, e.year, e.month, e.record_type, e.start, this.state.length)
  }

  // renderReportStoreOutPage(stockType,title) {
  //   let {config,isMobile} = this.props
  //   if (stockType==='genpart' && config.showStoreOutTab) {
  //     return(
  //           <Tab 
  //             eventKey={'report-store-out'}
  //             title={title}
  //           >
              
  //             <ReportStoreOutPage
  //               ref={stockType+'-report-store-out'} 
  //               tool={stockType} 
  //               config={this.props.config}
  //               isMobile={isMobile}
  //             />           
  //           </Tab>
  //     )
  //   } else {
  //     return('')
  //   }  
  // }

  // renderAnyExportPage() {
  //   let {tabSelect} = this.state
  //   let {isMobile} = this.props
  //   return(
  //     <StockAnyExportReport
  //       show={"pickup"===tabSelect}
  //       isMobile={isMobile}
  //     />     
  //   )
  // }

  renderTab(stockType){
    let {messages,isMobile} = this.props
    let title = (<div><FontAwesome name='search'/> {messages['Search']}</div>)
    let title2 = (<div><FontAwesome name='list-ol'/> {messages['In/Out']}</div>)
    // let title3 = (<div><FontAwesome name='exclamation-circle'/> {messages['Out Of Stock']}</div>)
    // let title4 = (<div><FontAwesome name='check-circle-o'/> {messages['Check Stock']}</div>)

    // if (stockType=='pickup') {
    //   return this.renderAnyExportPage()
    // } else if (stockType=='report-store-out') {
    //   return(
    //     <ReportStoreOutPage
    //       ref={'genpart-report-store-out'} 
    //       tool={'genpart'} 
    //       config={this.props.config}
    //       isMobile={isMobile}
    //     />
    //   )
    // }
    return(
      <div>
        <Row>
          <Col md={12}>
            <Tabs 
              defaultActiveKey={this.state.subTabSelect}
              animation={false} 
              id="noanim-tab-example"
              onSelect={this.subHandleSelect.bind(this, stockType)}
            >
              <Tab 
                eventKey="search"
                title={title}
              >
                <StockTyreSearchPage 
                  isMobile={isMobile} 
                  ref={stockType+'-search'} 
                  tool={stockType} 
                  config={this.props.config}
                />
              </Tab>
              <Tab 
                eventKey="inout"
                title={title2}
              >
                <StockTransactionReport 
                  tool={stockType}
                  data={this.state.data}
                  totalPage={this.state.totalPage}
                  loading={this.state.loading}
                  loadData={this.onStockTransactionLoad.bind(this)}
                  isMobile={isMobile}
                />            
              </Tab>              
            </Tabs>
          </Col>
        </Row>
      </div>  
    )
  }

  render() {
    let {messages} = this.props
    // let {warehouse} = this.state
    // let rTitle = (<div><FontAwesome name='bullseye'/> {messages['Old Tyre']}</div>)
    // let rTitle2 = (<div><FontAwesome name='bullseye'/> {messages['New Tyre']}</div>)
    let rTitle3 = (<div><FontAwesome name='bullseye'/> {messages['Retired Tyre']}</div>)
    let rTitle6 = (<div><FontAwesome name='bullseye'/> {messages['Active Tyre']}</div>)
    // let rTitle4 = (<div><FontAwesome name='wpforms'/> {'เบิกของ'}</div>)
    // let rTitle5 = (<div><FontAwesome name='file-text-o'/> {messages['Report Store Out']}</div>)
    let rSetting = (<div><FontAwesome name='gear'/></div>)
    return ( 
      <div>
        <Row>        
          <Col md={12}>
            <Tabs 
              activeKey={this.state.tabSelect} 
              animation={false} 
              id="stock-tabs"
              onSelect={this.handleSelect.bind(this)}
            >                        
              {/* <Tab 
                eventKey="oldtyre"
                title={rTitle}
              >
                {this.renderTab('oldtyre')}
              </Tab>
              <Tab 
                eventKey="newtyre"
                title={rTitle2}
              >
                {this.renderTab('newtyre')}
              </Tab> */}
              <Tab 
                eventKey="activetyre"
                title={rTitle6}
              >
                {this.renderTab('activetyre')}
              </Tab>
              <Tab 
                eventKey="retiredtyre"
                title={rTitle3}
              >
                {this.renderTab('retiredtyre')}
              </Tab>
              {/* {
                warehouse.map((item,index)=>(
                  <Tab 
                    key={index}
                    eventKey={"tyre"+(item.warehouse_id)}
                    title={(<div><FontAwesome name='bullseye'/> {item.name}</div>)}
                  >
                    
                    {this.renderTab("tyre"+(item.warehouse_id))}
                  </Tab>
                ))
              } */}
              {/* <Tab
                eventKey="officemate"
                title={rTitle3}
              >
                {this.renderTab('officemate')}
              </Tab>
              {this.props.config.showPickupTab
              ?
              <Tab
                eventKey="pickup"
                title={rTitle4}
              >
                {this.renderTab('pickup')}
              </Tab>
              :''}
              {this.props.config.showStoreOutTab
              ?
              <Tab
                eventKey="report-store-out"
                title={rTitle5}
              >
                {this.renderTab('report-store-out')}
              </Tab>
              :''} */} 
              <Tab
                eventKey="setting"
                title={rSetting}
              >
              </Tab>
            </Tabs>
          </Col>
        </Row>
        {/* <StockWarehouseManagementModal
          show={this.state.showAdd}
          onHide={this.onShowAddHide.bind(this)}
          onUpdate={this.onReloadWarehouse.bind(this)}
          onReload={this.onReloadStockList.bind(this)}
        /> */}
      </div>  
    );
  }
}

StockTyreManagementPage.defaultProps = {
  config : {showCostPerUnitField:true,showStoreOutTab:false,showCheckStockTab:true,showPickupTab:false}
}

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 480,
})

export default StockTyreManagementPage = compose(connect(
  (state) => ({messages: state.message.view.tyre.stock.StockTyreManagementPage}),null,null,{withRef:true}
),withSizes(mapSizesToProps))(StockTyreManagementPage);





// WEBPACK FOOTER //
// ./src/view/tyre/stock/StockTyreManagementPage.js